import React from 'react'
import '../App.css'
import { getSensorIds } from '../utils/trackable'
import { LATEST_METRIC, CURRENT_METRIC } from '../query/metric'
import FullListContent from '../components/FullListContent'
import { Query } from 'react-apollo'
import CircularProgress from '@material-ui/core/CircularProgress'
import { omegaClient } from '../graphql/omegaClient'

class FullContent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      latestMetrics: [],
      sensorIds: this.getSensorIds()
    }
    this.pollingInterval = null
    this._isMounted = false
  }
  getSensorIds () {
    return getSensorIds(this.props.trackables)
  }

  latestMetrics (trackableLabels) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: LATEST_METRIC,
          variables: { trackable_labels: trackableLabels },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.latest_metrics)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  fetchData () {
    this.latestMetrics(this.state.sensorIds)
      .then((latestMetrics) => {
        if (this._isMounted) {
          this.setState({
            latestMetrics
          })
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  componentDidMount () {
    this._isMounted = true
    // Fetch data immediately
    this.fetchData()

    // Set up polling every 1 minute (60000ms)
    this.pollingInterval = setInterval(() => {
      this.fetchData()
    }, 60000)
  }

  componentWillUnmount () {
    this._isMounted = false
    // Clear interval to prevent memory leaks
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  }

  renderQueryFull () {
    return (
      <div style={styles.contentList}>
        {this.state.latestMetrics.length === 0 ? (
          <CircularProgress style={styles.progressStyle} color='inherit' />
        ) : (
          <FullListContent
            sensorIds={this.state.sensorIds}
            fullMetrics={this.state.latestMetrics}
            keySearch={this.props.keySearch}
            fetchData={() => this.fetchData()}
            trackables={this.props.trackables}
          />
        )}
      </div>
    )
  }

  render () {
    const self = this
    return <div>{self.renderQueryFull()}</div>
  }
}

const styles = {
  contentList: {
    marginLeft: '14px'
  },
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '56px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  progressStyle: {
    marginTop: '25px',
    color: '#7ED321'
  },
  paginationProgressPosition: {
    marginTop: '20%'
  },
  listProgressPosition: {
    marginTop: '10%'
  }
}

export default FullContent
